import ChevronRight from "../Icons/ChevronRight";
import Loader from "../Loader";
import SaltBrandHeader from "./SaltBrandHeader";

const LandingPage = ({
	ctaText,
	image,
	title,
	subTitle,
	isLoading,
	onStart,
}: {
	image: string;
	title: string;
	subTitle: string;
	ctaText: string;
	isLoading: boolean;
	onStart: () => void;
}) => {
	return (
		<>
			<div className="flex flex-direction-column" style={{ flex: 1 }}>
				<div className="mlr-3">
					<SaltBrandHeader />
				</div>
				{image && (
					<img
						src={image}
						data-cy-id="landing_img"
						alt={title}
						width={"100%"}
						loading="lazy"
						className="mtb-3 plr-3"
					/>
				)}
				{title && (
					<h2 className="fs-18 fw-700 font-secondary mt-0 mb-1 plr-3">
						{title}
					</h2>
				)}
				{subTitle && (
					<p className="fs-16 fw-500 font-secondary color-abyssal-blue-300 mt-0 mb-5 plr-3">
						{subTitle}
					</p>
				)}
				<div className="flex justify-content-space-between mlr-3 mb-2">
					<span className="fs-16 fw-500 color-abyssal-blue-400 font-secondary">
						{ctaText}
					</span>
					<button
						className="round-btn"
						tabIndex={0}
						onClick={() => {
							if (!isLoading) {
								onStart();
							}
						}}
						data-cy-id="start-btn"
					>
						{isLoading ? (
							<Loader size={12} />
						) : (
							<ChevronRight color="#FFF" height={14} />
						)}
					</button>
				</div>
				<div className="fs-12 fw-500 font-tertiary mt-auto mlr-3 color-abyssal-blue-300">
					You won’t be disclosing any personal finance data – we just want to
					help you understand your relationship with money so you can invest,
					save (and spend!) better.
				</div>
			</div>
			<style jsx>{`
				.round-btn {
					height: 32px;
					width: 32px;
					border-radius: 50%;
					background: var(--primary-500);
					border: none;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			`}</style>
		</>
	);
};

export default LandingPage;
